export const formatterRate = (value) => `${value}%`;

export const parserRate = (value) => value?.replace("%", "");
